import * as yup from "yup";

export const CREATE_SOURCE_INITIAL_VALUES = {
  referenceSourceName: "",
  referenceSourceDescription: "",
  referenceType: "",
  scope: "",
  drafter: "",
  approver: "",
};

export const CREATE_SOURCE_VALIDATION_SCHEMA = {
  referenceSourceName: yup
    .string()
    .trim()
    .required("Reference Source Name is a required field."),
  referenceSourceDescription: yup.string().trim(),
  referenceType: yup.object().required("Reference Type is a required field."),
  scope: yup.object().required("Scope is a required field."),
  drafter: yup.object().required("Drafter is a required field."),
  approver: yup.object().required("Approver is a required field."),
};
